import { Navbar as Component } from './Navbar'
import { NavbarCategoriesAPI } from '../../api/navbarCategories'

export const Navbar = () => {
  const { data: navItems, isLoading } = NavbarCategoriesAPI.useIndex()
  if (isLoading) return null
  return <Component navItems={navItems || []} />
}
